import { call, put, takeLatest } from 'redux-saga/effects';

import { broadcastPartDimensionsChange } from 'modules/quotes/quoteDetailsPage/hooks/useSyncQpvAndBaqTabs';
import { refreshBomRollup } from 'modules/quotes/quoteItems/data/actions';
import { getSimilarPartsKey } from 'modules/quotes/quoteItems/data/hooks';
import { refreshComponent } from 'modules/quotes/quoteItems/data/sagas';

import partService from 'services/partService';

import { queryClient } from 'utils/QueryClientProvider';

import { types, updateGeometricAttributes } from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_GEOMETRIC_ATTRIBUTES_REQUEST,
    watchUpdateGeometricAttributes,
  );
}

function* watchUpdateGeometricAttributes(action) {
  const { payload } = action;
  const { componentId, part, sizeX, sizeY, sizeZ, volume, area, units } =
    payload;

  try {
    yield call(partService.updateForBAQ, part.uuid, {
      sizeX,
      sizeY,
      sizeZ,
      volume,
      area,
      units,
    });
    const nextComponent = yield call(refreshComponent, componentId, {
      refresh: true,
    });
    const { parentComponentIds, isRootComponent } = nextComponent;
    if (!isRootComponent) {
      yield put(refreshBomRollup.request({ parentComponentIds }));
    }
    queryClient.invalidateQueries({
      queryKey: getSimilarPartsKey(componentId),
    });
    broadcastPartDimensionsChange({
      context: {
        componentId,
        partUuid: part.uuid,
      },
    });

    yield put(updateGeometricAttributes.success());
  } catch (error) {
    yield put(updateGeometricAttributes.error(error));
  }
}
